// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* variables */
:root {
  --primary: #1d5d9b;
  --secondary: #068fff;
}

/* CSS Reset */
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  text-decoration: none;
  list-style-type: none;
}
/* End CSS Reset */

html {
  scroll-behavior: smooth;
}

/* Detail Restaurant */
.detail-restaurant {
  margin-top: 100px;
}

.image-detail-wrapper {
  text-align: center;
}

.image-detail-wrapper img {
  width: 80%;
  height: 63vh;
  object-fit: cover;
}

.restaurant-detail-head {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 134px;
  color: black;
  margin-top: 15px;
}

.restaurant-detail-head h1 {
  font-size: 2.3rem;
}

.rating-detail-container {
  margin-left: 10px;
  font-size: 1.1rem;
  margin-top: 5px;
}

.fa-star.detail {
  color: black;
}

.card-rating-detail {
  display: inline-block;
}

.city-address-detail-container {
  position: absolute;
  right: 133px;
  top: 50%;
  text-align: right;
}

.detail-city {
  display: inline-block;
  margin-bottom: 0;
}

.detail-road {
  margin-top: 5px;
}

.restaurant-detail-category-container {
  display: flex;
  margin-left: 138px;
  position: relative;
  bottom: -15px;
  color: white;
  margin-top: 7px;
}

.restaurant-detail-category-container > div {
  padding: 5px 10px;
  background-color: var(--primary);
}

.restaurant-detail-category-container > div:nth-child(2n + 2) {
  background-color: var(--secondary);
  margin-left: 8px;
}

.button-detail-container {
  position: absolute;
  right: 133px;
  top: 600px;
}

.button-detail-container .favorite {
  padding: 14px;
  background-color: white;
  border: var(--primary) solid 1px;
  color: var(--primary);
  cursor: pointer;
  font-weight: 800;
  border-radius: 5px;
  min-width: 44px;
  min-height: 44px;
}

.button-detail-container .favorite:hover {
  background-color: var(--primary);
  color: white;
}

.button-detail-container .favorite i {
  font-size: 15px;
}

.detail-description {
  width: 81%;
  margin: 60px auto;
}
/* Detail Restaurant */

/* Menus */

.menus-detail-container {
  width: 70%;
  text-align: center;
  margin: auto;
}

.foods-container,
.drinks-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
  align-items: flex-start;
}

.drink-text {
  margin-top: 40px;
}

.food-item,
.drink-item {
  padding: 10px;
  text-align: center;
  width: 290px;
  height: 100%;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.food-item:hover,
.drink-item:hover {
  transform: scale(1.05);
}

.food-item i,
.drink-item i {
  font-size: 2.3rem;
  margin-right: 10px;
}

.food-item p,
.drink-item p {
  font-size: 1.1rem;
  margin: 0;
}
/* End Menus */

/* Reviews */
.review-container {
  width: 80%;
  text-align: center;
  margin: 40px auto 0 auto;
}

.review-card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.review-card {
  width: 30%;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  text-align: center;
}

.review-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.review-image {
  font-size: 2rem;
}

.review-details h3 {
  font-size: 1.2rem;
  margin: 0;
}

.review-details p {
  font-size: 0.9rem;
  margin: 5px 0;
}

.review-content p {
  font-size: 1rem;
  margin: 10px 0;
}
/* End Reviews */

/* Review Form */
.review-form {
  background-color: #f0f0f0;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  width: 65%;
  margin: 40px auto 0 auto;
  background-color: #f0f0f0;
}

.review-form h2 {
  margin-bottom: 10px;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  font-weight: bold;
  text-align: start;
}

input[type='text'],
textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 44px;
  min-height: 44px;
}

textarea {
  resize: vertical;
}

button[type='submit'] {
  background-color: var(--primary);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
  min-width: 44px;
  min-height: 44px;
}

button[type='submit']:hover {
  background-color: #134276;
}
/* End Review Form */

/* Loading and Error */
.loading-indicator {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-message {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5em;
  color: red;
}

/* End Loading and Error */

footer {
  margin-top: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/detail-restaurant.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;AACA,kBAAkB;;AAElB;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA,sBAAsB;;AAEtB,UAAU;;AAEV;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,SAAS;AACX;AACA,cAAc;;AAEd,YAAY;AACZ;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA,gBAAgB;;AAEhB,gBAAgB;AAChB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA,oBAAoB;;AAEpB,sBAAsB;AACtB;EACE,0BAA0B,EAAE,eAAe;EAC3C,8BAA8B,EAAE,SAAS;EACzC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;AACZ;;AAEA,0BAA0B;;AAE1B;EACE,gBAAgB;AAClB","sourcesContent":["/* variables */\n:root {\n  --primary: #1d5d9b;\n  --secondary: #068fff;\n}\n\n/* CSS Reset */\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  text-decoration: none;\n  list-style-type: none;\n}\n/* End CSS Reset */\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Detail Restaurant */\n.detail-restaurant {\n  margin-top: 100px;\n}\n\n.image-detail-wrapper {\n  text-align: center;\n}\n\n.image-detail-wrapper img {\n  width: 80%;\n  height: 63vh;\n  object-fit: cover;\n}\n\n.restaurant-detail-head {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-left: 134px;\n  color: black;\n  margin-top: 15px;\n}\n\n.restaurant-detail-head h1 {\n  font-size: 2.3rem;\n}\n\n.rating-detail-container {\n  margin-left: 10px;\n  font-size: 1.1rem;\n  margin-top: 5px;\n}\n\n.fa-star.detail {\n  color: black;\n}\n\n.card-rating-detail {\n  display: inline-block;\n}\n\n.city-address-detail-container {\n  position: absolute;\n  right: 133px;\n  top: 50%;\n  text-align: right;\n}\n\n.detail-city {\n  display: inline-block;\n  margin-bottom: 0;\n}\n\n.detail-road {\n  margin-top: 5px;\n}\n\n.restaurant-detail-category-container {\n  display: flex;\n  margin-left: 138px;\n  position: relative;\n  bottom: -15px;\n  color: white;\n  margin-top: 7px;\n}\n\n.restaurant-detail-category-container > div {\n  padding: 5px 10px;\n  background-color: var(--primary);\n}\n\n.restaurant-detail-category-container > div:nth-child(2n + 2) {\n  background-color: var(--secondary);\n  margin-left: 8px;\n}\n\n.button-detail-container {\n  position: absolute;\n  right: 133px;\n  top: 600px;\n}\n\n.button-detail-container .favorite {\n  padding: 14px;\n  background-color: white;\n  border: var(--primary) solid 1px;\n  color: var(--primary);\n  cursor: pointer;\n  font-weight: 800;\n  border-radius: 5px;\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.button-detail-container .favorite:hover {\n  background-color: var(--primary);\n  color: white;\n}\n\n.button-detail-container .favorite i {\n  font-size: 15px;\n}\n\n.detail-description {\n  width: 81%;\n  margin: 60px auto;\n}\n/* Detail Restaurant */\n\n/* Menus */\n\n.menus-detail-container {\n  width: 70%;\n  text-align: center;\n  margin: auto;\n}\n\n.foods-container,\n.drinks-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.drink-text {\n  margin-top: 40px;\n}\n\n.food-item,\n.drink-item {\n  padding: 10px;\n  text-align: center;\n  width: 290px;\n  height: 100%;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease-in-out;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.food-item:hover,\n.drink-item:hover {\n  transform: scale(1.05);\n}\n\n.food-item i,\n.drink-item i {\n  font-size: 2.3rem;\n  margin-right: 10px;\n}\n\n.food-item p,\n.drink-item p {\n  font-size: 1.1rem;\n  margin: 0;\n}\n/* End Menus */\n\n/* Reviews */\n.review-container {\n  width: 80%;\n  text-align: center;\n  margin: 40px auto 0 auto;\n}\n\n.review-card-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n}\n\n.review-card {\n  width: 30%;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  text-align: center;\n}\n\n.review-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.review-image {\n  font-size: 2rem;\n}\n\n.review-details h3 {\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.review-details p {\n  font-size: 0.9rem;\n  margin: 5px 0;\n}\n\n.review-content p {\n  font-size: 1rem;\n  margin: 10px 0;\n}\n/* End Reviews */\n\n/* Review Form */\n.review-form {\n  background-color: #f0f0f0;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  width: 65%;\n  margin: 40px auto 0 auto;\n  background-color: #f0f0f0;\n}\n\n.review-form h2 {\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\nlabel {\n  display: block;\n  font-weight: bold;\n  text-align: start;\n}\n\ninput[type='text'],\ntextarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  min-width: 44px;\n  min-height: 44px;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nbutton[type='submit'] {\n  background-color: var(--primary);\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.3s;\n  min-width: 44px;\n  min-height: 44px;\n}\n\nbutton[type='submit']:hover {\n  background-color: #134276;\n}\n/* End Review Form */\n\n/* Loading and Error */\n.loading-indicator {\n  border: 16px solid #f3f3f3; /* Light grey */\n  border-top: 16px solid #3498db; /* Blue */\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.error-message {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5em;\n  color: red;\n}\n\n/* End Loading and Error */\n\nfooter {\n  margin-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
